import { memo } from 'react';
import { useSelector } from 'react-redux';

import { Button, Flex } from 'antd';

import { isPastDate } from '../../../helpers/date';

import { EVENT_MODAL_MODE, INVITE_STATUS, RELATION_SUBTYPE } from '../../../constants/event';

function EventModalFooter({
  currentEvent,
  modalMode = EVENT_MODAL_MODE.GUEST,
  newEvent,
  onAcceptClick,
  onCancelClick,
  onCreateClick,
  onDeclineClick,
  onDeleteClick,
  onDeleteRecurringEventsClick,
  onEditClick,
  onUpdateClick
}) {
  const { user } = useSelector(state => state.user);

  const isEventOwner = currentEvent?.is_owner;
  const isPast = isPastDate(currentEvent?.end_at, user?.timezone);

  const handleRemoveExternalEmail = (relationType) => {
    if (!Boolean(relationType)) return '';
    switch (relationType) {
      case RELATION_SUBTYPE.BREEDING:
      case RELATION_SUBTYPE.LIVESTOCK:
      case RELATION_SUBTYPE.MEASURE:
      case RELATION_SUBTYPE.TREATMENT:
        return 'livestock';
      case RELATION_SUBTYPE.ROTATION:
        return 'pasture';
      default:
        return '';
    }
  };

  const relationWithSubtype = handleRemoveExternalEmail(currentEvent?.relations_with_subtypes?.at(0)?.relation_subtype);

  return (
    <Flex className="w-full" gap="small" justify="end" key="actions">
      {relationWithSubtype ? (
        <p className="w-full" style={{ textAlign: 'left' }}>Check the {relationWithSubtype} details page to edit this event.</p>
      ) 
      : (<>
        {modalMode === EVENT_MODAL_MODE.VIEW && isEventOwner && (
          <Flex className="w-full" vertical={false} align="center" justify="space-between" gap="small">
            <Flex gap="small">
              <Button danger size="large" type="primary" onClick={onDeleteClick}>
                Delete
              </Button>
              {currentEvent?.recurring_id && (
                <Button danger size="large" type="primary" onClick={onDeleteRecurringEventsClick}>
                  Delete all recurring events
                </Button>
              )}
            </Flex>
            <Flex gap="small">
              <Button size="large" color="secondary" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button size="large" color="primary" variant="solid" onClick={onEditClick}>
                Edit
              </Button>
            </Flex>
          </Flex>
        )}

        {modalMode === EVENT_MODAL_MODE.UPDATE && isEventOwner && (
          <>
            <Button size="large" color="secondary" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button disabled={!newEvent?.title} size="large" color="primary" variant="solid" onClick={onUpdateClick}>
              Update
            </Button>
          </>
        )}

        {modalMode === EVENT_MODAL_MODE.CREATE && (
          <>
            <Button size="large" color="secondary" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button disabled={!newEvent?.title} size="large" color="primary" variant="solid" onClick={onCreateClick}>
              Create
            </Button>
          </>
        )}

        {modalMode !== EVENT_MODAL_MODE.CREATE && !isEventOwner && !isPast && (
          <Flex gap="small" justify="space-between">
            <Button size="large" color="secondary" onClick={onCancelClick}>
              Cancel
            </Button>
            <Flex vertical={false} gap="small">
              <Button
                disabled={currentEvent?.status === INVITE_STATUS.DECLINED}
                danger
                size="large"
                type="primary"
                onClick={onDeclineClick}>
                Decline
              </Button>
              <Button
                disabled={currentEvent?.status === INVITE_STATUS.ACCEPTED}
                size="large"
                type="primary"
                onClick={onAcceptClick}>
                Accept
              </Button>
            </Flex>
          </Flex>
        )}
      </>)
      }
    </Flex>
  );
}

export default memo(EventModalFooter);
